import { ROUTER_API } from 'app/constants/api.constant';
import BaseApi from 'app/services/api/base.api';
import { CriterionDescriptor, ResolvedSegment, SegmentClient, SegmentEditData } from '../type';

export const listCategoryApiV2 = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token', timeout: 60000 });

export const SEGMENT_CLIENTS_PAGE_SIZE = 100;

interface SegmentClientsPage {
  total: number;
  clients: SegmentClient[];
}

export const getSegmentsApi = async (franchiseId: string) => {
  const response = await listCategoryApiV2.api.get<ResolvedSegment[]>(`api/v2/franchises/${franchiseId}/segments`);
  return response.data;
};

export const getFilterSchemaApi = async (franchiseId: string) => {
  const response = await listCategoryApiV2.api.get<CriterionDescriptor[]>(
    `api/v2/franchises/${franchiseId}/segments/filter-schema`,
  );
  return response.data;
};

export const createCustomSegmentApi = async (franchiseId: string, body: SegmentEditData) => {
  const response = await listCategoryApiV2.api.post<ResolvedSegment>(`api/v2/franchises/${franchiseId}/segments`, body);
  return response.data;
};

export const toggleSegmentApi = async (
  franchiseId: string,
  ref: string,
  isEnabled: boolean,
  label?: string,
  description?: string,
) => {
  const response = await listCategoryApiV2.api.patch<ResolvedSegment>(
    `api/v2/franchises/${franchiseId}/segments/${ref}/toggle`,
    { isEnabled, label, description },
  );
  return response.data;
};

export const updateSegmentApi = async (franchiseId: string, ref: string, body: SegmentEditData) => {
  const response = await listCategoryApiV2.api.put<ResolvedSegment>(
    `api/v2/franchises/${franchiseId}/segments/${ref}`,
    body,
  );
  return response.data;
};

export const resetSegmentApi = async (franchiseId: string, ref: string) => {
  const response = await listCategoryApiV2.api.post<ResolvedSegment>(
    `api/v2/franchises/${franchiseId}/segments/${ref}/reset`,
  );
  return response.data;
};

export const deleteSegmentApi = async (franchiseId: string, ref: string) => {
  await listCategoryApiV2.api.delete(`api/v2/franchises/${franchiseId}/segments/${ref}`);
};

export const getSegmentClientsApi = async (
  franchiseId: string,
  ref: string,
  skip = 0,
  limit = SEGMENT_CLIENTS_PAGE_SIZE,
) => {
  const response = await listCategoryApiV2.api.get<SegmentClientsPage>(
    `api/v2/franchises/${franchiseId}/segments/${ref}/clients`,
    { params: { skip, limit } },
  );
  return response.data;
};
